import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";

const CustomerCard = ({ name, designation, videoID, small }) => {
  return (
    <Box
      width={small ? "265" : "400"}
      height={small ? "150" : "250"}
      margin="0 auto"
      padding="24px"
      display="flex"
      flexDirection="column"
      position="relative"
      color="black"
      textAlign="center"
      borderRadius="8px"
      overflow="hidden"
    >
      <Box flex="1" display="flex" justifyContent="center" alignItems="center">
        <a
          href={`https://www.youtube.com/watch?v=${videoID}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <iframe
            width={small ? "265" : "400"}
            height={small ? "150" : "250"}
            src={`https://www.youtube.com/embed/${videoID}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ borderRadius: "8px" }}
          ></iframe>
        </a>
      </Box>
      {!small && (
        <Text fontSize="20px" fontWeight="bold" margin="0" padding="0">
          {designation}
        </Text>
      )}
      {!small && (
        <Text fontSize="16px" fontWeight="200">
          {name}
        </Text>
      )}
    </Box>
  );
};

export default CustomerCard;
